<template>
  <div class="uk-column-1-1 uk-flex uk-flex-column full-width">
    <HeadingSecondary title="Assign Teams" />

    <div class="uk-card uk-card-default uk-card-body new-article-card" style="flex-grow: 1">
      <form class="uk-flex uk-flex-column" style="height: 100%">
        <div class="uk-flex uk-flex-row" v-if="organization" style="height: 100%">
          <div style="width: 45%">
            <HeadingSecondary title="Organization Members" :small="true" />
            <DataTable
              class="dense-table"
              :value="availableOrganizationMembers"
              :row-hover="true"
              :selection.sync="selectedOrgMembers"
              selectionMode="multiple"
              dataKey="_id"
            >
              <Column header="Name" :sortable="true">
                <template #body="memberProps">
                  <span>{{
                    memberProps.data.user
                      ? memberProps.data.user.name
                      : memberProps.data.invitation.name
                  }}</span>
                </template>
              </Column>
            </DataTable>
          </div>

          <div
            class="uk-flex uk-flex-column uk-margin-small-left uk-margin-small-right"
            style="width: 55%"
          >
            <div class="uk-flex uk-flex-row" style="height: 50%">
              <div class="uk-flex uk-flex-column uk-margin-small-left uk-margin-small-right">
                <div style="flex-grow: 1"></div>
                <div>
                  <div
                    class="uk-button uk-button-secondary uk-border-rounded-top"
                    @click="moveToTeam('for')"
                  >
                    <span uk-icon="icon: arrow-right"></span>
                  </div>
                </div>
                <div>
                  <div
                    class="uk-button uk-button-secondary uk-border-rounded-bottom"
                    @click="moveFromTeam('for')"
                  >
                    <span uk-icon="icon: arrow-left"></span>
                  </div>
                </div>
                <div style="flex-grow: 1"></div>
              </div>

              <div style="flex-grow: 1">
                <div class="uk-flex uk-flex-row">
                  <HeadingSecondary title="For" :small="true" />
                  <div style="flex-grow: 1"></div>
                  <select
                    class="uk-select uk-margin-left"
                    style="width: 75%"
                    @change="setTeam($event, 'for')"
                  >
                    <option :value="null">None</option>
                    <option v-for="team in organizationTeams" :value="team._id" :key="team._id">
                      {{ team.name }}
                    </option>
                  </select>
                </div>
                <DataTable
                  class="dense-table"
                  :value="teamMembers.for"
                  :row-hover="true"
                  :selection.sync="selectedTeamMembers.for"
                  selectionMode="multiple"
                  dataKey="organizationMember._id"
                >
                  <Column header="Name" :sortable="true">
                    <template #body="memberProps">
                      <span>{{
                        memberProps.data.organizationMember.user
                          ? memberProps.data.organizationMember.user.name
                          : memberProps.data.organizationMember.invitation.name
                      }}</span>
                    </template>
                  </Column>
                  <Column header="Role" :sortable="true">
                    <template #body="memberProps">
                      <select
                        class="uk-select"
                        :name="`${memberProps.data._id}-role`"
                        :id="`${memberProps.data._id}-role`"
                        v-model="memberProps.data.role"
                      >
                        <option :value="option" v-for="option in roleOptions" :key="option">
                          {{ option }}
                        </option>
                      </select>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
            <div class="uk-flex uk-flex-row" style="height: 50%">
              <div class="uk-flex uk-flex-column uk-margin-small-left uk-margin-small-right">
                <div style="flex-grow: 1"></div>
                <div>
                  <div
                    class="uk-button uk-button-secondary uk-border-rounded-top"
                    @click="moveToTeam('against')"
                  >
                    <span uk-icon="icon: arrow-right"></span>
                  </div>
                </div>
                <div>
                  <div
                    class="uk-button uk-button-secondary uk-border-rounded-bottom"
                    @click="moveFromTeam('against')"
                  >
                    <span uk-icon="icon: arrow-left"></span>
                  </div>
                </div>
                <div style="flex-grow: 1"></div>
              </div>

              <div style="flex-grow: 1">
                <div class="uk-flex uk-flex-row">
                  <HeadingSecondary title="Against" :small="true" />
                  <div style="flex-grow: 1"></div>
                  <select
                    class="uk-select uk-margin-left"
                    style="width: 75%"
                    @change="setTeam($event, 'against')"
                  >
                    <option :value="null">None</option>
                    <option v-for="team in organizationTeams" :value="team._id" :key="team._id">
                      {{ team.name }}
                    </option>
                  </select>
                </div>

                <DataTable
                  class="dense-table"
                  :value="teamMembers.against"
                  :row-hover="true"
                  :selection.sync="selectedTeamMembers.against"
                  selectionMode="multiple"
                  dataKey="organizationMember._id"
                >
                  <Column header="Name" :sortable="true">
                    <template #body="memberProps">
                      <span>{{
                        memberProps.data.organizationMember.user
                          ? memberProps.data.organizationMember.user.name
                          : memberProps.data.organizationMember.invitation.name
                      }}</span>
                    </template>
                  </Column>
                  <Column header="Role" :sortable="true">
                    <template #body="memberProps">
                      <select
                        class="uk-select"
                        :name="`${memberProps.data._id}-role`"
                        :id="`${memberProps.data._id}-role`"
                        v-model="memberProps.data.role"
                      >
                        <option :value="option" v-for="option in roleOptions" :key="option">
                          {{ option }}
                        </option>
                      </select>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>

        <div class="uk-margin uk-width-1-1">
          <button
            class="uk-button uk-button-default uk-button-primary uk-width-1-1 uk-border-rounded"
            @click.prevent="submitForm"
            @keypress.enter="submitForm"
            :disabled="!teamsAreValid"
          >
            Save
            <InlineLoader class="uk-margin-left" :status="savingStatus" />
          </button>
        </div>

        <div class="uk-width-1-1 uk-text-warning">
          <div v-if="!teamValidation.for.hasMembers">For Team Needs Members</div>
          <div v-if="teamValidation.for.hasMembers && !teamValidation.for.hasLeader">
            For Team Needs Team Lead
          </div>
          <div v-if="!teamValidation.against.hasMembers">Against Team Needs Members</div>
          <div v-if="teamValidation.against.hasMembers && !teamValidation.against.hasLeader">
            Against Team Needs Team Lead
          </div>
          <div v-if="teamValidation.sameMember">
            The same person cannot be a Member of both Teams
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- end column -->
</template>

<script>
import { reactive, computed } from 'vue';
import InlineLoader from '@/components/general/InlineLoader';
import HeadingSecondary from '@/components/general/HeadingSecondary';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { mapActions, mapGetters, mapState } from 'vuex';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
  name: 'DocumentOrganizationTeamAssignment',
  components: {
    InlineLoader,
    HeadingSecondary,
    DataTable,
    Column,
  },
  setup() {
    const form = reactive({
      name: '',
    });

    const rules = computed(() => ({
      form: {
        name: { required },
      },
    }));

    const v$ = useVuelidate(rules, { form });

    return { form, v$: v$.value };
  },
  async mounted() {
    this.organizationId = this.$route.query.organizationId;
    this.teamId = this.$route.params.id;
    if (!this.organization && this.$route.query.organizationId) {
      await this.loadOrganizationDetails(this.$route.query.organizationId);
    }
    //
    // load organization teams
    this.organizationTeams = await this.loadAllCurrentOrganizationTeams();
    //
    // lodad organization members
    this.organizationMembers = await this.loadAllCurrentOrganizationMembers();
  },
  data() {
    return {
      roleOptions: ['Member', 'Team Lead'],
      organizationTeams: [],
      organizationMembers: [],
      selectedOrgMembers: [],
      selectedTeamMembers: {
        for: [],
        against: [],
      },
      teamMembers: {
        for: [],
        against: [],
      },
      teamId: null,
      organizationId: null,
      formFields: {
        name: {
          type: 'text',
          icon: null,
          placeholder: 'Give your team a name',
        },
      },
      savingStatus: '',
    };
  },
  computed: {
    ...mapState(['organizationDetailsCache']),
    ...mapGetters([]),
    organization() {
      return this.organizationDetailsCache[this.organizationId];
    },
    availableOrganizationMembers() {
      if (this.organization) {
        const ids = Object.values(this.teamMembers).flatMap(team =>
          team.map(x => x.organizationMember._id)
        );
        return this.organizationMembers.filter(x => !ids.includes(x._id) && x.user);
      }
      return [];
    },
    teamValidation() {
      return {
        for: {
          hasLeader: this.teamMembers.for.filter(x => x.role === 'Team Lead').length === 1,
          hasMembers: this.teamMembers.for.length > 0,
        },
        against: {
          hasLeader: this.teamMembers.against.filter(x => x.role === 'Team Lead').length === 1,
          hasMembers: this.teamMembers.against.length > 0,
        },
        sameMember: this.teamMembers.for.some(member => this.teamMembers.against.includes(member)),
      };
    },
    teamsAreValid() {
      return (
        this.teamValidation.for.hasLeader &&
        this.teamValidation.for.hasMembers &&
        this.teamValidation.against.hasLeader &&
        this.teamValidation.against.hasMembers &&
        !this.teamValidation.sameMember
      );
    },
  },
  methods: {
    ...mapActions([
      'loadOrganizationDetails',
      'loadAllCurrentOrganizationMembers',
      'loadAllCurrentOrganizationTeams',
    ]),
    submitForm() {
      this.$emit('onSubmit', this.teamMembers);
    },
    moveToTeam(target) {
      this.teamMembers[target] = [
        ...this.teamMembers[target],
        ...this.selectedOrgMembers
          .filter(x => x.user)
          .map(x => ({
            organizationMember: x,
            role: 'Member',
          })),
      ];
      this.selectedOrgMembers = [];
    },
    moveFromTeam(target) {
      const ids = this.selectedTeamMembers[target].map(x => x.organizationMember._id);
      this.teamMembers[target] = this.teamMembers[target].filter(
        teamMember => !ids.includes(teamMember.organizationMember._id)
      );
      this.selectedTeamMembers[target] = [];
    },
    setTeam(event, target) {
      const team = this.organizationTeams.find(team => team._id === event.target.value);
      if (team) {
        this.teamMembers[target] = team.members.filter(m => m.organizationMember.user);
      } else {
        this.teamMembers[target] = [];
      }
    },
  },
};
</script>

<style lang="sass">
.p-datatable tbody.p-datatable-tbody > tr
  & > td
    padding: 0.25rem
  & > th
    padding: 0.25rem
</style>
